/* WKR customer fit video rail. No dependencies. */
(function () {
  if (window.customElements.get('wkr-ugc')) return;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function loadSource(video) {
    if (video.dataset.loaded === '1') return;
    var hls = video.dataset.hls;
    var nativeHls = hls && video.canPlayType('application/vnd.apple.mpegurl');
    video.src = nativeHls ? hls : video.dataset.src;
    video.dataset.loaded = '1';
  }

  function safePlay(video) {
    loadSource(video);
    var p = video.play();
    if (p && typeof p.catch === 'function') p.catch(function () {});
  }

  function muteAllExcept(keepItem) {
    document.querySelectorAll('.wkr-ugc__item[aria-pressed="true"]').forEach(function (item) {
      if (item === keepItem) return;
      item.setAttribute('aria-pressed', 'false');
      var v = item.querySelector('video');
      if (v) v.muted = true;
    });
  }

  class WkrUgc extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      this.rail = this.querySelector('.wkr-ugc__rail');
      this.prev = this.querySelector('.wkr-ugc__arrow--prev');
      this.next = this.querySelector('.wkr-ugc__arrow--next');
      this.items = Array.prototype.slice.call(this.querySelectorAll('.wkr-ugc__item'));
      if (!this.rail || !this.items.length) return;

      this._onScroll = this.updateArrows.bind(this);
      this.rail.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', this._onScroll, { passive: true });

      var self = this;
      if (this.prev) this.prev.addEventListener('click', function () { self.page(-1); });
      if (this.next) this.next.addEventListener('click', function () { self.page(1); });

      this.items.forEach(function (item) {
        item.addEventListener('click', function () { self.toggleSound(item); });
      });

      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var video = entry.target.querySelector('video');
            if (!video) return;
            if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
              if (!reduceMotion) safePlay(video);
            } else if (!video.paused) {
              video.pause();
            }
          });
        }, { threshold: [0, 0.6] });
        this.items.forEach(function (item) { self.io.observe(item); });
      }

      this.updateArrows();
    }

    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      if (this.rail) this.rail.removeEventListener('scroll', this._onScroll);
      window.removeEventListener('resize', this._onScroll);
      this._ready = false;
    }

    page(dir) {
      this.rail.scrollBy({ left: dir * this.rail.clientWidth * 0.9, behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    updateArrows() {
      var max = this.rail.scrollWidth - this.rail.clientWidth;
      var x = this.rail.scrollLeft;
      var hasPrev = x > 4;
      var hasNext = x < max - 4;
      if (this.prev) this.prev.hidden = !hasPrev;
      if (this.next) this.next.hidden = !hasNext;
      this.classList.toggle('has-prev', hasPrev);
      this.classList.toggle('has-next', hasNext);
    }

    toggleSound(item) {
      var video = item.querySelector('video');
      if (!video) return;
      var on = item.getAttribute('aria-pressed') === 'true';
      if (on) {
        video.muted = true;
        item.setAttribute('aria-pressed', 'false');
        return;
      }
      muteAllExcept(item);
      video.muted = false;
      item.setAttribute('aria-pressed', 'true');
      safePlay(video);
    }
  }

  window.customElements.define('wkr-ugc', WkrUgc);
})();
